module.exports = __webpack_public_path__ + "static/2-6f25ebe77a394ee9c5560e703b328158.jpeg";